import React from 'react'
import { cn } from '../../../lib/utils'

export interface CalmShellPlaceholderProps {
  variant?: 'public' | 'app'
  className?: string
}

export const CalmShellPlaceholder: React.FC<CalmShellPlaceholderProps> = ({
  variant = 'public',
  className,
}) => {
  return (
    <div
      className={cn('min-h-screen bg-background-50 text-ink-700', className)}
      data-shell-variant={variant}
    />
  )
}

export default CalmShellPlaceholder
